<script setup lang="ts">
import { ref, computed, watch, onMounted,onBeforeUnmount } from 'vue'
import { useI18n } from 'vue-i18n';
import { useCountriesStore } from '@/stores/countries';
import { storeToRefs } from 'pinia';
import messages from './locales/messages'
const { t, locale } = useI18n({
    useScope: 'global',
    messages
})
const countriesStore = useCountriesStore();
const { countries: countriesInStore } = storeToRefs(countriesStore)
const countriesFavoriteOrder = [
    'FR', 'BE', 'DE', 'IT', 'ES', 'NL', 'LU', 'PT', 'AT', 'IE', 'DK', 'SE', 'FI', 'NO', 'PL', 'CZ', 'SK', 'HU', 'RO', 'BG', 'HR', 'SI', 'LT', 'LV', 'EE', 'GR', 'CY', 'MT'
]
const props = defineProps({
    shippingCountries: {
        type: Object,
        required: true
    },
    userCountry: {
        type: String,
        required: true
    }
})

const selectedCountry = ref('');

const selectedName = computed(() => {
    const country = countriesInStore.value.find((c) => c.iso == selectedCountry.value)
    return country ? country.content[locale.value] : ''
})

const availableCountries = computed(() => {
    // we make a copy of the countries Store
    
    const countries = [... countriesInStore.value]
    // we sort the countries by the favorite order
    countries.sort((a, b) => {
        // if not in the favorites then order alphabetically using the active locale key
        if (!countriesFavoriteOrder.includes(a.iso) && !countriesFavoriteOrder.includes(b.iso)) {
            return (a.content[locale.value] || "").localeCompare(b.content[locale.value] || "")
        }
        // if one of the two is not in the favorites, we put it at the end
        if (!countriesFavoriteOrder.includes(a.iso)) {
            return 1
        }
        if (!countriesFavoriteOrder.includes(b.iso)) {
            return -1
        }
        return countriesFavoriteOrder.indexOf(a.iso) - countriesFavoriteOrder.indexOf(b.iso)
    })
    // if the selected country is not in the list, we select the first one
    if (!countries.find((c) => c.iso == selectedCountry.value)) {
        selectedCountry.value = countries[0].iso
    }
    return countries
})

// the component is called with a v-model
const shippingCost = defineModel();
const selectedShipping = defineModel('shipping');
const show_countries = ref(false);
const selectCountryRef = ref(null);
const availableShipping = ref([]);


const show_shippings = ref(false);
const selectShippingRef = ref(null);

function switch_show_countries(event){
    event.stopPropagation()
    if(!show_countries.value){
        show_shippings.value = false
    }
    show_countries.value = !show_countries.value
}
function switch_show_shippings(event){
    event.stopPropagation()
    if(!show_shippings.value){
        show_countries.value = false
    }
    show_shippings.value = !show_shippings.value
}
function handleClickOutside(event: MouseEvent) {
    if (show_countries.value && selectCountryRef.value && !selectCountryRef.value.contains(event.target as Node)) {
        console.log('event target', event.target)
        show_countries.value = false;
    }
}
function handleClickOutside2(event: MouseEvent) {
    if (show_shippings.value && selectShippingRef.value && !selectShippingRef.value.contains(event.target as Node)) {
        console.log('event target', event.target)
        show_shippings.value = false;
    }
}
function selectCountry(iso){
    selectedCountry.value = iso
    show_countries.value = false
}
function selectShipping(shipping){
    selectedShipping.value = shipping
    shippingCost.value = shipping.tarif_ttc
    show_shippings.value = false
}

watch(selectedCountry, (newVal)=>{
    let a = [];
    if(props.shippingCountries[newVal]){
        a = props.shippingCountries[newVal]
        // we sort by tarif_ttc 
        a.sort((a,b)=>{
            return a.tarif_ttc - b.tarif_ttc
        })
        // we rename the shipper name depending of their content, if contain "Relai" then we set it as t('cart.shipping_options.relay_point'), if contains "Chrono" then we set it as t('cart.shipping_options.express') otherwise we set it as t('cart.shipping_options.home')
        a.forEach((s)=>{
            if(s.shipper.toLowerCase().includes('relai')){
                s.name = t('cart.shipping_options.relay_point')
            }
            else if(s.shipper.toLowerCase().includes('chrono')){
                s.name = t('cart.shipping_options.express')
            }
            else{
                s.name = t('cart.shipping_options.home')
            }
            if( s.tarif_ttc == 0){
                    s.name += ' - '+t('cart.free')
                }
                else{
                    s.name += ' - '+s.tarif_ttc.toFixed(2).replace('.',',')+' €'
                }
        })
        // we select the first one
        selectedShipping.value = a[0]
        // and we set the shipping cost
        shippingCost.value = a[0].tarif_ttc        
    }
    else{
        selectedShipping.value = null
        shippingCost.value = 0
    }
    availableShipping.value = a
})
function noClose(event) {
    event.stopPropagation()
}
onMounted(() => {
    document.addEventListener('click', handleClickOutside)
    document.addEventListener('click', handleClickOutside2)

    // if user country not in the countries list, we select the first of favorites
    if (!countriesInStore.value.find((c) => c.iso == props.userCountry)) {
        selectedCountry.value = countriesFavoriteOrder[0]
    }
    else{
        selectedCountry.value = props.userCountry
    }
})
onBeforeUnmount(() => {
    document.removeEventListener('click', handleClickOutside)
    document.removeEventListener('click', handleClickOutside2)
})


</script>
<template>
    <label>{{ $t('cart.shiiping_country') }}</label>
    <div class="the_select" @click="switch_show_countries">
        {{ selectedName}}
        <div class="the_select_options" ref="selectCountryRef" v-if="show_countries" @click="noClose">
            <table>
                <tbody>
                    <tr v-for="country in availableCountries" :key="country.iso" @click="selectCountry(country.iso)" :class="{selected : selectedCountry == country.iso}">
                        <td>
                            {{ country.content[locale] }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <label>{{ $t('cart.shipping') }}</label>
    <div v-if="availableShipping.length==0" class="the_select">
        {{ $t('cart.shipping_options.none') }}
    </div>
    <div v-else class="the_select" @click="switch_show_shippings">
        {{ selectedShipping ? selectedShipping.name : $t('cart.shipping_options.select') }}
        <div class="the_select_options" ref="selectShippingRef" v-if="show_shippings" @click="noClose">
            <table>
                <tbody>
                    <tr v-for="shipping in availableShipping" :key="shipping.id" @click="selectShipping(shipping)" :class="{selected : selectedShipping == shipping}">
                        <td>
                            {{ shipping.name }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<style lang="scss" scoped>
label{
    width: 100%;
    font-family: Montserrat;
    font-weight: 700;
    font-size: 14px;
    line-height: 17.07px;
    letter-spacing: 0%;
    color: #FFF;
    margin-top: 10px;
}
.the_select{
    width: 100%;
    margin-top: 5px;
    color: #000;
    background-color: #FFF;
    border-radius: 16px;
    padding: 3px 20px 5px 10px;
    position: relative;
    cursor: pointer;
    transition: all 0.3s;
    &:after{
        content: '';
        position: absolute;
        top: 50%;
        right: 10px;
        transform: translateY(-50%);
        width: 0;
        height: 0;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-top: 5px solid #000;
    }
    &:hover{
        background-color: #b6b6b6;
    }
    .the_select_options{
        width: 100%;
        position: absolute;
        left: 0;
        top: 100%;
        background-color: #FFF;
        max-width: calc(100vw - 20px);
        border-radius: 16px;
        box-shadow: 0 0 15px rgba(0,0,0,0.8);
        padding: 5px;
        z-index: 1000;
        table{
            width: 100%;
            td{
                
                white-space: nowrap;
                text-align: left;
                padding: 5px;
                border-bottom: 1px solid #0000002b;
            }
            tbody{
                tr{
                    cursor: pointer;
                    transition: all 0.3s;
                    &:hover{
                        background-color: #0000002b;
                    }
                    &.selected{
                        background-color: #0000002b;
                    }
                    &:last-child{
                        td{
                            border-bottom: none;
                        }
                    }
                }
            }
        }
    }
}
</style>